/* ============================================================================
 * custom-accessibility.js  ·  Remediación WCAG 2.1 AA — TNS USA
 * ----------------------------------------------------------------------------
 * Cada módulo está envuelto en try/catch para que un fallo aislado NUNCA
 * rompa el resto de la página. Si un selector no coincide, el módulo
 * simplemente no hace nada (degradación segura).
 *
 * ⚠️ PROBAR con lector de pantalla (NVDA/VoiceOver) en un tema DUPLICADO
 *    antes de publicar. Los módulos E y F dependen de selectores del tema
 *    y pueden requerir ajuste tras la prueba en vivo.
 * ==========================================================================*/
(function () {
  "use strict";

  var ready = function (fn) {
    if (document.readyState !== "loading") { fn(); }
    else { document.addEventListener("DOMContentLoaded", fn); }
  };

  function safe(name, fn) {
    try { fn(); } catch (e) { if (window.console) console.warn("[a11y] " + name + " falló:", e); }
  }

  /* -----------------------------------------------------------------------
   * MÓDULO A — Original: roles en SVG + botones del widget Google Reviews
   * --------------------------------------------------------------------- */
  function moduleReviewsAndSvg() {
    document.querySelectorAll("svg").forEach(function (svg) {
      if (!svg.hasAttribute("role")) svg.setAttribute("role", "presentation");
    });

    var buttonClasses = ["grp-slider-prev", "grp-slider-next", "grp-dot", "dot"];
    function applyButtonRoles(root) {
      root = root || document;
      buttonClasses.forEach(function (className) {
        root.querySelectorAll("." + className).forEach(function (el) {
          if (!el.hasAttribute("role")) el.setAttribute("role", "button");
          if (!el.hasAttribute("aria-label")) el.setAttribute("aria-label", "Navigation Google Reviews");
        });
      });
    }
    applyButtonRoles();

    var observer = new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.classList.contains("grp-entangle--root")) {
            applyButtonRoles(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    var interval = setInterval(function () {
      var widgetRoot = document.querySelector(".grp-entangle--root");
      if (widgetRoot) { applyButtonRoles(widgetRoot); clearInterval(interval); }
    }, 500);
  }

  /* -----------------------------------------------------------------------
   * MÓDULO B — Región aria-live para anunciar cambios dinámicos
   * (barrera k: confirmación al seleccionar talla; cambios de carrito)
   * --------------------------------------------------------------------- */
  var announce = (function () {
    var region;
    function ensure() {
      if (region) return region;
      region = document.createElement("div");
      region.setAttribute("aria-live", "polite");
      region.setAttribute("aria-atomic", "true");
      region.className = "a11y-visually-hidden";
      region.id = "a11y-live-region";
      document.body.appendChild(region);
      return region;
    }
    return function (msg) {
      if (!msg) return;
      var r = ensure();
      r.textContent = "";
      // pequeño retraso para forzar la relectura por el lector de pantalla
      setTimeout(function () { r.textContent = msg; }, 60);
    };
  })();
  window.__a11yAnnounce = announce;

  /* -----------------------------------------------------------------------
   * MÓDULO C — Herramientas del mini-carrito operables por teclado
   * (barrera b: "Estimate Shipping" / "Add a Coupon" son <div>, se saltan)
   * --------------------------------------------------------------------- */
  function moduleCartToolButtons() {
    function enhance(root) {
      (root || document).querySelectorAll("[data-cart-tool_action]").forEach(function (el) {
        if (el.dataset.a11yReady) return;
        el.dataset.a11yReady = "1";
        if (!el.hasAttribute("role")) el.setAttribute("role", "button");
        if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "0");
        if (!el.hasAttribute("aria-label")) {
          var txt = (el.textContent || "").trim();
          if (txt) el.setAttribute("aria-label", txt);
        }
        el.addEventListener("keydown", function (ev) {
          if (ev.key === "Enter" || ev.key === " " || ev.key === "Spacebar") {
            ev.preventDefault();
            el.click();
          }
        });
      });
    }
    enhance();
    // El drawer del carrito se re-renderiza por AJAX: re-aplicar en cambios.
    var mc = document.getElementById("t4s-mini_cart") || document.body;
    new MutationObserver(function () { safe("cartTools", function () { enhance(mc); }); })
      .observe(mc, { childList: true, subtree: true });
  }

  /* -----------------------------------------------------------------------
   * MÓDULO D — Anuncio y estado al seleccionar talla/variante
   * (barrera k — WCAG 4.1.2)
   * --------------------------------------------------------------------- */
  function moduleVariantSelection() {
    document.addEventListener("click", function (ev) {
      var item = ev.target.closest("[data-swatch-item], .t4s-swatch-grid__item");
      if (!item) return;
      safe("variantAnnounce", function () {
        var value = item.getAttribute("data-value") || (item.textContent || "").trim();
        var group = item.closest("[data-swatch-option]");
        var name = "";
        if (group) {
          var titleEl = group.querySelector("[data-swatch-name], .t4s-swatch-grid__title");
          if (titleEl) name = (titleEl.textContent || "").replace(/\s+/g, " ").trim();
        }
        // marca aria-pressed en el grupo
        if (group) {
          group.querySelectorAll("[data-swatch-item], .t4s-swatch-grid__item").forEach(function (el) {
            el.setAttribute("aria-pressed", el === item ? "true" : "false");
            if (!el.hasAttribute("role")) el.setAttribute("role", "button");
            if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "0");
          });
        }
        if (value) announce((name ? name + " " : "") + value + " — selected");
      });
    }, true);

    // permitir activar swatches con teclado
    document.addEventListener("keydown", function (ev) {
      var item = ev.target.closest && ev.target.closest("[data-swatch-item], .t4s-swatch-grid__item");
      if (!item) return;
      if (ev.key === "Enter" || ev.key === " " || ev.key === "Spacebar") {
        ev.preventDefault(); item.click();
      }
    });

    // Inicializa role/tabindex/aria-pressed AL CARGAR (y en re-render por AJAX):
    // así la talla preseleccionada ya se anuncia como "selected" y todas son
    // enfocables antes del primer clic.
    function initSwatches(root) {
      (root || document).querySelectorAll("[data-swatch-item], .t4s-swatch-grid__item").forEach(function (el) {
        if (!el.hasAttribute("role")) el.setAttribute("role", "button");
        if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "0");
        el.setAttribute("aria-pressed", el.classList.contains("is--selected") ? "true" : "false");
      });
    }
    initSwatches();
    new MutationObserver(function (list) {
      safe("swatchInit", function () {
        list.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1 && (n.matches && (n.matches("[data-swatch-item],[data-swatch-option],.t4s-swatch-grid__item") || n.querySelector("[data-swatch-item], .t4s-swatch-grid__item")))) {
              initSwatches(n);
            }
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* -----------------------------------------------------------------------
   * MÓDULO C2 — Disparadores de modal activables por teclado
   * (el botón "Size Guide" es un <a> sin href; Enter no lo abría)
   * --------------------------------------------------------------------- */
  function moduleModalTriggers() {
    document.addEventListener("keydown", function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var trigger = t.closest(".boton-modal, [data-modal]");
      if (!trigger) return;
      if (ev.key === "Enter" || ev.key === " " || ev.key === "Spacebar") {
        ev.preventDefault();
        trigger.click();
      }
    });
  }

  /* -----------------------------------------------------------------------
   * MÓDULO E — Menú principal accesible por teclado (barrera a — WCAG 2.1.1)
   * Añade aria-expanded y dispara la carga diferida (lazy) del mega-menú
   * cuando el ítem recibe foco por teclado (el tema solo lo hace en hover).
   * --------------------------------------------------------------------- */
  function moduleMenuKeyboard() {
    var parents = document.querySelectorAll(".t4s-menu-item.has--children");
    parents.forEach(function (li) {
      var link = li.querySelector(":scope > a");
      if (link && !link.hasAttribute("aria-expanded")) link.setAttribute("aria-expanded", "false");

      function open() {
        if (link) link.setAttribute("aria-expanded", "true");
        // dispara el hover del tema para cargar el contenido lazy del mega-menú
        li.dispatchEvent(new MouseEvent("mouseenter", { bubbles: true }));
      }
      function close() {
        if (link) link.setAttribute("aria-expanded", "false");
      }

      li.addEventListener("focusin", function () { safe("menuOpen", open); });
      li.addEventListener("focusout", function (ev) {
        if (!li.contains(ev.relatedTarget)) safe("menuClose", close);
      });
      // Escape cierra y devuelve el foco al enlace padre
      li.addEventListener("keydown", function (ev) {
        if (ev.key === "Escape") { close(); if (link) link.focus(); }
      });
    });
  }

  /* -----------------------------------------------------------------------
   * MÓDULO F — Gestión de foco en diálogos/drawers
   * (barreras d, e, g: filtros, Size Guide, drawer del carrito no reciben foco)
   * Cuando un contenedor de la lista se vuelve visible: role=dialog,
   * aria-modal, mueve el foco dentro, atrapa Tab, Esc para cerrar y
   * restaura el foco al cerrar.
   * --------------------------------------------------------------------- */
  function moduleDialogFocus() {
    // Selectores de contenedores tipo diálogo. Confirmados con el cliente:
    //   .modal-contenido = modal custom "Size Guide" (cierra con .modal-cerrar)
    var DIALOG_SELECTORS = [
      ".modal-contenido",        // modal Size Guide (confirmado)
      "#sizeguide",              // id del modal Size Guide (respaldo)
      ".t4s-drawer",             // TODOS los drawers del tema (carrito, filtros, login, menú)
      "#t4s-mini_cart",          // drawer del carrito
      "#t4s-filter-hidden",      // drawer de filtros de colección (CONFIRMADO)
      ".mfp-content",            // Magnific Popup (quickview, size chart ajax)
      ".t4s-quickview__content",
      // "What's My Size?" — widget Modi-fit (se renderiza en el DOM con clases modi-*)
      "[class*='modi-modal']",
      "[class*='modi-dialog']",
      "[class*='modi-overlay']",
      "[class*='modi-panel']",
      "[role='dialog']"          // cualquier diálogo estándar que aparezca
    ];
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function isVisible(el) {
      if (!el) return false;
      if (el.getAttribute("aria-hidden") === "true") return false;
      var cs = window.getComputedStyle(el);
      if (cs.display === "none" || cs.visibility === "hidden" || parseFloat(cs.opacity) === 0) return false;
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    }

    var active = null;       // diálogo activo
    var lastFocus = null;    // foco previo para restaurar
    var trapHandler = null;

    function activate(dialog) {
      if (active === dialog) return;
      deactivate();
      active = dialog;
      lastFocus = document.activeElement;

      if (!dialog.hasAttribute("role")) dialog.setAttribute("role", "dialog");
      dialog.setAttribute("aria-modal", "true");

      // etiqueta el diálogo si no tiene nombre
      if (!dialog.hasAttribute("aria-label") && !dialog.hasAttribute("aria-labelledby")) {
        var heading = dialog.querySelector("h1,h2,h3,h4,[data-cart-tab-title]");
        if (heading) dialog.setAttribute("aria-label", (heading.textContent || "Dialog").trim());
      }

      // mueve el foco al primer elemento enfocable (o al contenedor)
      var focusables = dialog.querySelectorAll(FOCUSABLE);
      var first = focusables[0] || dialog;
      if (first === dialog && !dialog.hasAttribute("tabindex")) dialog.setAttribute("tabindex", "-1");
      setTimeout(function () { try { first.focus(); } catch (e) {} }, 50);

      // atrapa Tab dentro del diálogo
      trapHandler = function (ev) {
        if (ev.key === "Escape") { requestClose(dialog); return; }
        if (ev.key !== "Tab") return;
        var f = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), isVisible);
        if (!f.length) return;
        var firstF = f[0], lastF = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === firstF) { ev.preventDefault(); lastF.focus(); }
        else if (!ev.shiftKey && document.activeElement === lastF) { ev.preventDefault(); firstF.focus(); }
      };
      document.addEventListener("keydown", trapHandler, true);
    }

    function deactivate() {
      if (!active) return;
      active.removeAttribute("aria-modal");
      if (trapHandler) document.removeEventListener("keydown", trapHandler, true);
      trapHandler = null;
      var toRestore = lastFocus;
      active = null; lastFocus = null;
      if (toRestore && document.contains(toRestore)) { try { toRestore.focus(); } catch (e) {} }
    }

    // intenta cerrar el diálogo usando los botones de cierre del tema
    function requestClose(dialog) {
      var closer = dialog.querySelector("[data-a11y-close], .modal-cerrar, [data-drawer-close], .t4s-drawer__close, .mfp-close, [data-close], [data-modal-close]");
      if (closer) closer.click();
      else deactivate();
    }

    // Registro de visibilidad previa por elemento: SOLO activamos un diálogo
    // que pasa de OCULTO -> VISIBLE. Así nada que ya esté visible al cargar
    // la página queda atrapado (evita romper la navegación).
    var visState = new WeakMap();
    var baselineDone = false;

    function collect() {
      var list = [];
      DIALOG_SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) { list.push(el); });
      });
      return list;
    }

    function scan() {
      safe("dialogScan", function () {
        var list = collect();
        var opened = null;
        list.forEach(function (el) {
          var vis = isVisible(el);
          var prev = visState.get(el) === true;
          visState.set(el, vis);
          if (baselineDone && vis && !prev && !opened) opened = el; // recién abierto
        });
        if (!baselineDone) { baselineDone = true; return; } // 1er pase: solo baseline
        if (opened) activate(opened);
        else if (active && !isVisible(active)) deactivate();
      });
    }

    // Observa cambios de atributos/estructura que indican apertura/cierre
    var mo = new MutationObserver(function () { scan(); });
    mo.observe(document.body, {
      attributes: true, attributeFilter: ["class", "style", "aria-hidden", "hidden"],
      childList: true, subtree: true
    });
    scan(); // establece baseline (no activa nada visible al cargar)
  }

  /* -----------------------------------------------------------------------
   * MÓDULO G — Etiqueta botones de cierre "×" que se anuncian como "times"
   * (barrera e — WCAG 4.1.2)
   * --------------------------------------------------------------------- */
  function moduleCloseButtons() {
    var CLOSE_SEL = ".modal-cerrar, .mfp-close, [data-drawer-close], .t4s-drawer__close, [data-close], [data-modal-close], .close-modal, .boton-cerrar";
    var isES = document.documentElement.lang === "es";
    var CLOSE_TXT = isES ? "Cerrar" : "Close";
    // Path del ícono "X" (Heroicons x-mark) usado por Modi-fit y otros widgets
    var X_PATH = /M6 ?18 ?18 ?6|M6 ?6 ?l?12 ?12|6 18L?18 6|18 6M6 6/i;

    function accessibleName(el) {
      return (el.getAttribute("aria-label") || "").trim() ||
             (el.textContent || "").trim().replace(/[×✕✖xX·✗⨯]/g, "").trim();
    }

    function tagClose(el) {
      if (!el.hasAttribute("aria-label")) el.setAttribute("aria-label", CLOSE_TXT);
      el.setAttribute("data-a11y-close", "1");
    }

    function label(root) {
      root = root || document;
      // 1) Botones de cierre conocidos por clase/atributo
      root.querySelectorAll(CLOSE_SEL).forEach(function (el) {
        if (!accessibleName(el)) tagClose(el);
      });
      // 2) Botones tipo icono (sin texto) cuyo SVG dibuja una "X" = cerrar
      root.querySelectorAll("button, [role='button'], a").forEach(function (el) {
        if (accessibleName(el)) return;                 // ya tiene nombre
        if (el.querySelector("img")) return;            // tiene imagen, no forzamos
        var path = el.querySelector("svg path");
        if (path && X_PATH.test(path.getAttribute("d") || "")) tagClose(el);
      });
    }
    label();
    new MutationObserver(function () { safe("closeBtns", function () { label(); }); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /* -----------------------------------------------------------------------
   * MÓDULO H — Etiqueta el botón del widget de accesibilidad (Avada)
   * (barrera h: se anuncia como "pajamas button"). Ajustar selector si Avada
   * cambia su marcado.
   * --------------------------------------------------------------------- */
  function moduleAvadaWidgetLabel() {
    var SELECTORS = [
      "#avada-accessibility", ".avada-accessibility", ".avada-acc-widget",
      "[class*='accessibility-widget']", "[id*='accessibility-widget']",
      ".acsb-trigger", "#acsb-trigger"
    ];
    function tryLabel() {
      var labeled = false;
      SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          var btn = el.matches("button,a,[role='button']") ? el : el.querySelector("button,a,[role='button']");
          btn = btn || el;
          if (!btn.getAttribute("aria-label")) {
            btn.setAttribute("aria-label",
              document.documentElement.lang === "es" ? "Menú de accesibilidad" : "Accessibility menu");
            labeled = true;
          }
        });
      });
      return labeled;
    }
    if (tryLabel()) return;
    // Avada carga tarde: reintentar por unos segundos
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (tryLabel() || tries > 20) clearInterval(iv);
    }, 500);
  }

  /* -----------------------------------------------------------------------
   * MÓDULO I — Etiqueta controles de ícono del header sin nombre accesible
   * (cuenta, favoritos). Solo actúa si el control NO tiene texto ni aria-label.
   * --------------------------------------------------------------------- */
  function moduleHeaderIconLabels() {
    var isES = document.documentElement.lang === "es";
    var MAP = [
      { sel: ".t4s-site-nav__account a", en: "Account", es: "Cuenta" },
      { sel: "[data-link-wishlist]", en: "Wishlist", es: "Favoritos" },
      { sel: "[data-open-search], [data-toggle-search]", en: "Search", es: "Buscar" }
    ];
    function textName(el) {
      // texto visible menos números (contadores tipo "0")
      return (el.textContent || "").replace(/\d+/g, "").replace(/\s+/g, " ").trim();
    }
    MAP.forEach(function (m) {
      document.querySelectorAll(m.sel).forEach(function (el) {
        if (el.getAttribute("aria-label")) return;
        if (textName(el)) return; // ya tiene texto → no forzamos
        el.setAttribute("aria-label", isES ? m.es : m.en);
      });
    });
  }

  /* ------------------------------ CONFIG -------------------------------- */
  /* Módulo F (atrapar foco en diálogos) depende de selectores del tema y
   * DEBE probarse en un tema duplicado con lector de pantalla antes de
   * activarlo en producción. Cambia a `true` solo después de verificar que
   * el drawer del carrito, filtros y Size Guide abren/cierran bien y que el
   * foco NO queda atrapado al cargar la página.
   *
   * Activado: el módulo ahora SOLO atrapa el foco cuando un modal pasa de
   * oculto a visible (baseline en la carga), y los selectores del modal de
   * tallas están confirmados (.modal-contenido / .modal-cerrar). Aun así,
   * PRUEBA en tema duplicado el carrito y los filtros. Si algún drawer diera
   * problemas, vuelve a poner `false`. */
  var A11Y_ENABLE_DIALOG_FOCUS = true;

  /* ------------------------------ INIT ---------------------------------- */
  ready(function () {
    safe("A-reviewsSvg", moduleReviewsAndSvg);
    safe("C-cartTools", moduleCartToolButtons);
    safe("C2-modalTriggers", moduleModalTriggers);
    safe("D-variant", moduleVariantSelection);
    safe("E-menu", moduleMenuKeyboard);
    if (A11Y_ENABLE_DIALOG_FOCUS) safe("F-dialog", moduleDialogFocus);
    safe("G-close", moduleCloseButtons);
    safe("H-avada", moduleAvadaWidgetLabel);
    safe("I-headerIcons", moduleHeaderIconLabels);
  });
})();
